import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { FormFeedback, Input } from 'reactstrap';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import {
	useAddToPlayListMutation,
	useGetVideosListQuery,
	usePersonalPlayListByIdQuery,
	useSubmitPersonalPlayListMutation
} from '../../../service';
import { getVideoDropDownList } from '../../../redux/videoSlice';
import { useState } from 'react';
import playlistApi from '../../../api/playlistApi';
import axios from 'axios';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../../../data/atoms/utilsAtoms';
import Toast from '../../../utils/toastManager';

const DUPLICATE_PLAYLIST_MESSAGE = 'Unable to add this video because it is already in this playlist.';

const getVideoId = video => video?._id?.toString?.() || video?.value?.toString?.() || video?.id?.toString?.();

function PersonalPlayListForm({
	show,
	setShow,
	editPlaylistID,
	handleClose,
	nshowModal,
	setnModalShow,
	handleModalSubmit
}) {
	const {
		control,
		handleSubmit,
		reset,
		setValue,
		formState: { errors }
	} = useForm();
	const dispatch = useDispatch();
	const videoDropdownList = useSelector(state => state.videoState.videoDropdownList);

	const userData = useAtomValue(userInfoAtom);
	const [reqPersonal, resPersonal] = useSubmitPersonalPlayListMutation();
	const [resVideo, setResVideo] = useState([]);
	const [loading, setLoading] = useState(true);

	const { data, isLoading, isSuccess, error } = useGetVideosListQuery();

	useEffect(() => {
		if (isLoading) setLoading(true);
		if (error) console.log('error in get video list', error);
		if (isSuccess) setResVideo(data);
	}, [isLoading, isSuccess]);

	const [name, setName] = useState('');
	const [videos, setVideos] = useState([]);
	const [existingVideos, setExistingVideos] = useState([]);

	useEffect(() => {
		console.log('resVideo data', resVideo);
		if (resVideo) {
			const res1 = resVideo.map(el => ({
				...el,
				label: el.title,
				value: el._id
			}));
			dispatch(getVideoDropDownList(res1));
		}
	}, [resVideo, dispatch]);

	useEffect(() => {
		if (editPlaylistID) {
			setLoading(true);
			// console.log("editPlaylistID", editPlaylistID);
			axios
				.get(`${import.meta.env.VITE_APP_API_URL}/personalvideo/${editPlaylistID}`)
				.then(res => {
					console.log('response from get request', res.data);
					const formattedExistingVideos = res.data.existingVideos.videos.map(video => ({
						label: video.title, // Display title
						value: video._id, // Unique identifier
						...video // Keep other fields if needed
					}));

					setName(res.data.existingVideos.name);
					setExistingVideos(formattedExistingVideos);
					setVideos(res.data.existingVideos.videos);

					reset({
						createdAt: res.data.existingVideos.createdAt,
						description: res.data.existingVideos.description,
						name: res.data.existingVideos.name,
						videos: res.data.existingVideos.videos,
						id: res.data.existingVideos._id,
						userId: userData.user?.userId
					});
				})
				.catch(err => console.error('Error fetching playlist details:', err))
				.finally(() => setLoading(false));
		}
	}, [editPlaylistID, reset]);

	const onNext = async state => {
		try {
			const selectedVideoIds = (state.videos || []).map(getVideoId).filter(Boolean);
			if (new Set(selectedVideoIds).size !== selectedVideoIds.length) {
				Toast.error(DUPLICATE_PLAYLIST_MESSAGE);
				return;
			}

			const response = await playlistApi.saveNewPlaylist(
				{
					name: name,
					id: editPlaylistID,
					videos: state.videos,
					userId: userData.user?.userId
				},
				userData?.token
			);

			// Check if response is valid
			if (response) {
				// Update state with new playlist data
				setExistingVideos(state.videos);
				setVideos(state.videos);

				// Close modals
				setShow(false);
				setnModalShow(false);
				handleModalSubmit();
			}
		} catch (error) {
			console.error('Error updating playlist:', error);
			Toast.error(error?.response?.data?.message || 'Error updating playlist');
		}
	};

	return (
		<section>
			<div className="container">
				<div>
					<div className="">
						<div>
							<form onSubmit={handleSubmit(onNext)}>
								<div className="row g-2">
									<div className="col-md-12 form-group">
										<Input
											type="text"
											placeholder="Name"
											value={name}
											onChange={e => {
												setName(e.target.value);
												setValue('name', e.target.value);
											}}
										/>
										{errors.name && <FormFeedback>{errors.name.message}</FormFeedback>}
									</div>
									<div className="col-md-12 form-group">
										<Controller
											name="videos"
											control={control}
											rules={{
												required: 'At least one video must be selected'
											}}
											render={({ field }) => (
												<Select
													{...field}
													isMulti
													options={videoDropdownList || []}
													value={existingVideos || []}
													onChange={selected => {
														setVideos(selected);
														setExistingVideos(selected);
														field.onChange(selected);
													}}
													placeholder="Select videos"
												/>
											)}
										/>
										{errors.videos && <FormFeedback>{errors.videos.message}</FormFeedback>}
									</div>
									<div className="col-md-12 form-group action__btns text-end">
										<button
											className="btn btn-primary"
											type="submit"
											// disabled={loading}
										>
											{editPlaylistID ? 'Update' : 'Save'}
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default PersonalPlayListForm;
